import React from 'react';
import { Scientifica2023 } from 'views/SchoolProgram2023/components';

const SchoolProgrampage = () => {
  return <Scientifica2023/>;
};

export default SchoolProgrampage;